var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconNoResultsFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.699,
    height: 80,
    viewBox: "0 0 62.699 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_302",
    "data-name": "Union 302",
    d: "M9601.491,10400.171c-.04,0-.062.039-.1.039h-22.611a8.783,8.783,0,0,1-8.782-8.773v-52.654a8.792,8.792,0,0,1,8.782-8.782h22.308c.051,0,.087.054.136.06a1.236,1.236,0,0,1,.961.3l20.027,20.029a1.229,1.229,0,0,1,.324.879c0,.046.038.079.038.117v27.3a16.262,16.262,0,1,1-21.086,21.486Zm1.155-6.445a13.77,13.77,0,1,0,13.77-13.771A13.781,13.781,0,0,0,9602.646,10393.726Zm-30.143-54.943v52.646a6.291,6.291,0,0,0,6.279,6.278H9600.7a16.091,16.091,0,0,1-.547-3.981,16.293,16.293,0,0,1,16.273-16.273,15.833,15.833,0,0,1,3.647.451v-25.37h-11.315a8.719,8.719,0,0,1-8.713-8.705V10332.5h-21.262A6.288,6.288,0,0,0,9572.5,10338.782Zm30.043,5.046a6.212,6.212,0,0,0,6.2,6.2h9.446c-4.191-4.172-11.826-11.76-15.648-15.562Zm12.451,56.43a1.311,1.311,0,1,1,1.311,1.312A1.312,1.312,0,0,1,9615,10400.258Zm.262-5.245v-8.395a1.049,1.049,0,1,1,2.1,0v8.393a1.049,1.049,0,0,1-2.1,0Z",
    transform: "translate(-9570.001 -10330)",
    fill: "#304669",
    opacity: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNoResultsFound);
export default __webpack_public_path__ + "static/media/icon_no_results_found.87a252a1661633ab5ece4ddf58494f68.svg";
export { ForwardRef as ReactComponent };